import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secToMin'
})
export class SecToMinPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (typeof value === 'undefined') {
      return 'N/A';
    }
    let sec_num = parseInt(value);
    let hours: any = Math.floor(sec_num / 3600);
    let minutes: any = Math.floor((sec_num - (hours * 3600)) / 60);
    let seconds: any = sec_num - (hours * 3600) - (minutes * 60);

    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    return (hours <= 0 || hours === '00' ? '' : hours + ':') + minutes + ':' + seconds;
  }
}



// WEBPACK FOOTER //
// ./src/app/sec-to-min.pipe.ts